export const UPDATE_SENTIMENT_REPORT = "UPDATE_SENTIMENT_REPORT";
export const UPDATE_ACTIVE_DURATION = "UPDATE_ACTIVE_DURATION";
export const UPDATE_PRODUCT_SORTING = "UPDATE_PRODUCT_SORTING";
export const UPDATE_VIDEOS_SORTING = "UPDATE_VIDEOS_SORTING";
export const UPDATE_VIDEOS_SEARCH = "UPDATE_VIDEOS_SEARCH";
export const UPDATE_PLATFORMS = "UPDATE_PLATFORMS";

export const updatePlatforms = (platformsOption) => ({
  type: UPDATE_PLATFORMS,
  platformsOption,
});

export const updateActiveDuration = (selectedDuration) => ({
  type: UPDATE_ACTIVE_DURATION,
  selectedDuration,
});

export const updateActiveSortSentiment = (productsSortBy) => ({
  type: UPDATE_PRODUCT_SORTING,
  productsSortBy,
});

export const updateActiveSortVideos = (videosSortBy) => ({
  type: UPDATE_VIDEOS_SORTING,
  videosSortBy,
});

export const updateVideosSearch = ({ search }) => ({
  type: UPDATE_VIDEOS_SEARCH,
  search,
});

export const sentimentReportAction = (data) => ({
  type: UPDATE_SENTIMENT_REPORT,
  data,
});
